module.exports = __webpack_public_path__ + "static/media/student22.a8fc01ac.png";